module.exports = __webpack_public_path__ + "images/welzorg_smallc0b030197ff79d5fd31011a5af37aa6c.png";